module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'menu/vertical-accordeon' && templateVars.config ?
				templateVars.config :
				{
	"titleParam": [
		"menuTitle",
		"shortTitle"
	],
	"depthLevel": 4,
	"expandable": true,
	"closable": true,
	"documentClickClose": true,
	"highlightOnlyCurrent": true,
	"hidePreviousListOnExpand": false,
	"hideInnerOnClose": true,
	"fixedMenu": false,
	"columnsNum": 3,
	"columnClass": "col-4 col-md-6 col-sm-12",
	"animation": {
		"open": {
			"transition": "slideDown",
			"duration": 200
		},
		"close": {
			"transition": "slideUp",
			"duration": 200
		}
	},
	"additionalLinks": {
		"ar": {
			"ru": [
				{
					"title": "Дополнительная информация",
					"link": "/ru/90/",
					"modifier": "cl-item",
					"targetBlank": false,
					"static": true,
					"children": [
						{
							"title": "Об отчете",
							"text": "Об отчете",
							"link": "${rootUrl}/about-report/",
							"targetBlank": false
						},
						{
							"title": "Дисклеймер",
							"text": "Дисклеймер",
							"link": "${rootUrl}/disclaimer",
							"modifier": "disclaimer",
							"targetBlank": false
						},
						{
							"title": "Контакты",
							"text": "Контакты",
							"link": "${rootUrl}/contacts",
							"modifier": "contacts",
							"targetBlank": false
						},
						{
							"title": "Карта сайта",
							"link": "${rootUrl}/sitemap/",
							"targetBlank": false
						},
						{
							"title": "Политика Cookie",
							"link": "${rootUrl}/cookies-policy/",
							"targetBlank": false
						}
					]
				}
			],
			"en": [
				{
					"title": "Additional information",
					"link": "/en/90/",
					"modifier": "cl-item",
					"targetBlank": false,
					"static": true,
					"children": [
						{
							"title": "About report",
							"text": "About report",
							"link": "${rootUrl}/about-report/",
							"targetBlank": false
						},
						{
							"title": "Disclaimer",
							"text": "Disclaimer",
							"link": "${rootUrl}/disclaimer",
							"targetBlank": false
						},
						{
							"title": "Cookies",
							"text": "Cookies",
							"link": "${rootUrl}/cookies-policy/",
							"modifier": "cookies-policy",
							"targetBlank": false
						},
						{
							"title": "Contacts",
							"text": "Contacts",
							"link": "${rootUrl}/contacts",
							"targetBlank": false
						},
						{
							"title": "Sitemap",
							"link": "${rootUrl}/sitemap/",
							"targetBlank": false
						},
						{
							"title": "Cookies policy",
							"link": "${rootUrl}/cookies-policy/",
							"targetBlank": false
						}
					]
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/menu/.variant/vertical-accordeon/config.yaml
// module id = 103
// module chunks = 0